






































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import SaascadaVueProductForm from '@/components/Shared/SaascadaVueProductForm';
import DepositAccountSummary from "@/models/Accounts/DepositAccounts/DepositAccountSummary";
import BuySellFXRequest from '@/models/Accounts/DepositAccounts/Wallets/BuySellFXRequest';
import { DepositAccountSettingsModule } from '@/store/Accounts/DepositAccountSettingsModule';
import FieldLabel from '@/components/Shared/FieldLabel.vue';
import CurrencyUtils from '@/lib/currencyUtils';
import BuySellFXWalletType from "@/models/Accounts/DepositAccounts/BuySellFXWalletType";

@Component({ name: 'SelectCurrencies', components: { FieldLabel } })
export default class extends SaascadaVueProductForm {

    CurrencyUtils = CurrencyUtils;
    BuySellFXWalletType = BuySellFXWalletType;

    fxTypeOptions = ['Selling', 'Buying'];
    destinationWalletSelectionType = BuySellFXWalletType.ExistingWallet;

    @Prop({required: true})
    dialog: Boolean;

    @Prop({required: true})
    account: DepositAccountSummary;

    @Prop({required: true})
    buySellFXRequest: BuySellFXRequest;

    @Watch('buySellFXRequest.sourceWalletId')
    async onSourceWalletIdChanged(val: string) {
        if (val != '') {
            this.buySellFXRequest.sellCurrency = this.account.wallets.find(wallet => wallet.id === val).availableBalance.currency;
        }
    }

    get listOfCurrencies() {
        return CurrencyUtils.getListOfCurrencies();
    }

    get sourceWalletOptions() {
        return this.account.wallets;
    }

    get destinationWalletOptions() {
        const walletOptions = this.account.wallets.filter(wallet => wallet.balance.currency === this.buySellFXRequest.buyCurrency);
        if (walletOptions.length === 1) {
            this.buySellFXRequest.destinationWalletId = walletOptions[0].id;
        }
        return walletOptions;
    }

    get secondaryWalletTypeOptions() {
        return DepositAccountSettingsModule.productIssue.secondaryWalletSettings?.secondaryWalletTypes.filter(wallet => wallet.generalSettings.allowedCurrencies.includes(this.buySellFXRequest.buyCurrency));
    }

    get transferAmountCurrency() {
        if (this.buySellFXRequest.buySellDirection === 'Selling') {
            return this.buySellFXRequest.sellCurrency;
        }
        else {
            return this.buySellFXRequest.buyCurrency;
        }
    }
}
